import { Nullable } from "src/types"

export type AppInfo = {
  appName: string
  appVersion: string
}

let _serverUrl: Nullable<string> = null
let _accessToken: Nullable<string> = null
let _refreshToken: Nullable<string> = null
let _appInfo: Nullable<AppInfo> = null

function setAsclepiusServerUrl(url: string) {
  if (_serverUrl != null) throw Error("Asclepius config has already been initialized, it can only be inited once!")

  _serverUrl = url
}

function getAsclepiusServerUrl(): string {
  if (_serverUrl === null) throw Error("Asclepius server url has not yet been set, call `setAsclepiusServerUrl` first!")

  return _serverUrl
}

function clearAuthTokens() {
  _accessToken = null
  _refreshToken = null
}

function setAccessToken(accessToken: string) {
  _accessToken = accessToken
}

function getAccessToken(): Nullable<string> {
  return _accessToken
}

function setRefreshToken(refreshToken: string) {
  _refreshToken = refreshToken
}

function getRefreshToken(): Nullable<string> {
  return _refreshToken
}

/**
 * Identifies this app on the session plane (per-refresh UserLogin audit
 * attribution). Optional — refreshes without it are recorded unattributed.
 */
function setAppInfo(appInfo: AppInfo) {
  _appInfo = appInfo
}

function getAppInfo(): Nullable<AppInfo> {
  return _appInfo
}

export default {
  setAsclepiusServerUrl,
  getAsclepiusServerUrl,
  clearAuthTokens,
  setAccessToken,
  getAccessToken,
  setRefreshToken,
  getRefreshToken,
  setAppInfo,
  getAppInfo
}
